import { bool, string } from 'prop-types';

const GridRow = ({ titleRow, columnTitle, secondColumnTitle, propTitle, propsDesc }) => {
  if (titleRow) {
    return (
      <div className="titleRow">
        <div className="titleCell"> {columnTitle} </div>
        <div className="titleCell"> {secondColumnTitle} </div>
      </div>
    );
  } else {
    return (
      <div className="detailsRow">
        <div className="detailsTitle">{propTitle}</div>
        <div className="detailsTitle">{propsDesc}</div>
      </div>
    );
  }
};

GridRow.propTypes = {
  columnTitle: string,
  secondColumnTitle: string,
  propTitle: string,
  propsDesc: string,
  titleRow: bool
};

GridRow.defaultProps = {
  columnTitle: '',
  secondColumnTitle: '',
  propTitle: '',
  propsDesc: '',
  titleRow: false
};

export default GridRow;
